import Vue from 'vue'
import App from './App.vue'
import vSelect from 'vue-select'
import Vuelidate from "vuelidate";

import 'bootstrap'
//import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'jquery'
import 'jquery-ui'
import router  from "./router";
import http from "./http-common"
import "./assets/css/style-new.css"


//Custom css
import "./assets/css/bootstrap.min.css";
import "./assets/css/chat.css";
import "./assets/css/custom.css"
import "./assets/css/showLoading.css"
import "./assets/css/mobilechat.css"
import "./assets/css/webchat.css"
import "./assets/css/jquery-ui.min.css"
import "./assets/font-awesome/css/font-awesome.min.css"
import 'vue-select/dist/vue-select.css';

Vue.use(Vuelidate);

Vue.component('v-select', vSelect)

Vue.config.productionTip = false
Vue.prototype.$RtaWebChatBot = false
Vue.prototype.$RtaAppPath = "";
http
    .get("/frontendProperties").then(response => {
//fetch(process.env.BASE_URL + 'config.json').then(res=> res.json()).then(config => {
    Vue.prototype.$config = response.data;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var lang = urlParams.get('lang');

    var pathName = window.location.pathname;

    if (pathName.endsWith("/jsp/chat/closewindow.jsp")) {
        return;
    }

    if(lang === null || lang === 'undefined') {
        var concatParam = "?";
        if(queryString !='' && queryString !='undefined' && queryString != null) {
            concatParam = "&";
        }
        try {
            window.removeEventListener('beforeunload', this.beforeWindowUnload);
        } catch (e) {
            console.log("no event listener",e);
        }

        window.location.replace(window.location.href + concatParam + "lang=en&mobile=true")
    }
    if(lang == 'ar') {
        import("./assets/css/ar.css")
        import("./assets/css/style-new-ar.css")
    } else if(lang == 'en'){
        import("./assets/css/en.css")
    }


    http
        .get("/applicationConfigs").then(response => {
        var pathName = window.location.pathname;
        var appname = "";
        if(urlParams.get('appname') != null && urlParams.get('appname') != 'undefined') {
            appname = urlParams.get('appname');
        }

        Vue.prototype.$appname = appname;


        if(urlParams.get('conversationId') != null && urlParams.get('conversationId') != 'undefined' && urlParams.get('conversationId').trim() != '') {
            Vue.prototype.$conversationId = urlParams.get('conversationId');
        }

        var mobile = "true";
        if(urlParams.get('mobile') != null && urlParams.get('mobile') != 'undefined') {
            mobile = urlParams.get('mobile');
        }

        var applicationConfigs = response.data;
        Vue.prototype.$channel = "DEFAULT";
        var i = 0;
        for (i=0; i < applicationConfigs.length; i++) {
            if(pathName.includes("/" + applicationConfigs[i].apppath + "/")) {
                Vue.prototype.$RtaAppPath = applicationConfigs[i].apppath;
                if(applicationConfigs[i].apppath == "RtaWebChatBot") {
                    Vue.prototype.$RtaWebChatBot = true
                    import("./assets/css/bot.css")
                }
                Vue.prototype.$channel = applicationConfigs[i].channel;
                if((applicationConfigs[i].appname == appname || appname == "") && applicationConfigs[i].mobile.toString() == mobile) {
                    Vue.prototype.$color = applicationConfigs[i].color;
                    Vue.prototype.$disableColor = applicationConfigs[i].colorDisabled;
                }
            }
        }

        http
            .get("/textCnts", {params:  {lang: lang, channel: Vue.prototype.$channel}})
            .then(response => {
                var labelsList = response.data;
                var i = 0;
                var labels = new Array();
                for (i=0; i < labelsList.length; i++) {
                    labels[labelsList[i].textKey] = labelsList[i].textValue;
                }
                Vue.prototype.$labels = labels;
                Vue.prototype.$channel

                new Vue({
                    router,
                    render: h => h(App)
                }).$mount('#app')
            })
            .catch(e => {
                console.log(e);
            });

    })
        .catch(e => {
            console.log(e);
        });



})


